<template>
  <section class="section header-landing-section white">
    <div class="container">
      <h1 class="title is-spaced">{{ t('meclee-ui.landings.business.title') }}</h1>

      <div class="columns is-multiline has-text-centered">
        <div class="column is-12">
          <div class="columns">
            <video class="mx-auto max-h-[360px]" src="/meclee_b2b.mp4" autoplay controls muted loop />
          </div>
        </div>

        <div class="column is-12">
          <div class="columns">
            <SupportCard v-for="(text, index) in supportTexts" :key="index" :title="text">
              <template #img>
                <img src="/meclee-ui/images/b-1.svg" v-if="index === 0" :style="styles" loading="lazy" />
                <img src="/meclee-ui/images/b-2.svg" v-else-if="index === 1" :style="styles" loading="lazy" />
                <img src="/meclee-ui/images/b-3.svg" v-else-if="index === 2" :style="styles" loading="lazy" />
              </template>
            </SupportCard>
          </div>
        </div>
        <div class="column is-12">
          <Button @click="isModalActiveModel = true" class="action">{{ supportBtnText }}</Button>
        </div>
      </div>
    </div>
  </section>
</template>
<script setup lang="ts">
import SupportCard from "./SupportCard.vue"
import Button from "../Button.vue"
const { supportTexts, supportBtnText, isModalActive } = defineProps({
  supportTexts: Array,
  supportBtnText: String,
  isModalActive: Boolean,
})

const styles = {
  maxWidth: "300px",
  marginLeft: "auto",
  marginRight: "auto"
}

const emit = defineEmits(['update:isModalActive']);

const isModalActiveModel = computed({
  get() {
    return isModalActive;
  },
  set(value: boolean) {
    emit('update:isModalActive', value);
  }
});
const { t } = useI18n();
</script>
